import { Logger, LoggerTypes } from '../../utils'

export const SET_FLOW_GROUP_BPMN_STATE = 'SET_FLOW_GROUP_BPMN_STATE'

export const setBpmnState = (state) => async (dispatch) => {
  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowGroupBpmnActions.setBpmnState()', state)
  return dispatch({
    type: SET_FLOW_GROUP_BPMN_STATE,
    data: state
  })
}
